// @flow
import * as React from 'react'
import './styles.scss'
import type { BaseCoverProps, CoverWrapperProps } from 'components/cover/types'

export function Cover({
  children,
  coverHeight = '66vh',
  inverted = false,
  padding = '3ex',
  position = 'top',
  mobilePadding = padding,
  mobilePosition = position,
  poster,
  showTextShadow = true,
  showTopGradient = true,
  subtitle,
  title
}: BaseCoverProps & CoverWrapperProps) {
  const placeholderColorString = `rgb(${poster.placeholder.color[0]}, ${poster.placeholder.color[1]}, ${poster.placeholder.color[2]})`
  const transparentPlaceholderColorString = `rgba(${poster.placeholder.color[0]}, ${poster.placeholder.color[1]}, ${poster.placeholder.color[2]},0)`
  const textShadow = showTextShadow
    ? `0 0 2em ${placeholderColorString}, 0 0 0.75em ${placeholderColorString}`
    : 'none'

  return (
    <div
      className='cover'
      style={{
        backgroundColor: placeholderColorString,
        backgroundImage: `url(${poster.placeholder.url})`,
        height: coverHeight
      }}
    >
      {children}
      {showTopGradient && <div className='top gradient' />}

      <div
        className='ui mobile only title box'
        style={{
          position: 'absolute',
          bottom: mobilePadding,
          textShadow: textShadow
        }}
      >
        <div className='ui container'>
          <div className='ui header'>
            <h1>{title}</h1>
            <h2>{subtitle}</h2>
          </div>
        </div>
      </div>

      <div
        className='ui mobile hidden title box'
        style={{
          position: 'absolute',
          bottom: padding,
          left: 0,
          textShadow: textShadow
        }}
      >
        <div className='ui container'>
          <div className='ui header'>
            <h1 className={`ui ${inverted ? 'inverted' : ''} header`}>
              {title}
            </h1>
            <h2>{subtitle}</h2>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cover
